module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainProduct__imgWrap"
  }, [_c('img', {
    staticClass: "mainProduct__img",
    attrs: {
      "src": './src/assets/' + _vm.pathImg,
      "alt": _vm.alt
    },
    on: {
      "click": _vm.showOverlay
    }
  }), _vm._v(" "), (_vm.pageSize === 'M') ? _c('ul', {
    staticClass: "mainProduct__shareList"
  }, _vm._l((_vm.social), function(item, index) {
    return _c('li', [_c('a', {
      key: index,
      staticClass: "mainProduct__shareLink",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "mainProduct__shareImg",
      attrs: {
        "src": './src/assets/share/' + item,
        "alt": "item"
      }
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-562687f7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainImg.vue
// module id = 54
// module chunks = 0